import React, { useEffect } from "react";
import CustomPagination from "../../../components/CustomPagination";
import { useNavigate } from "react-router-dom";
import CustomButton from "../../../components/CustomButton";
import { ThunkDispatch } from "@reduxjs/toolkit";
import { useSelector, useDispatch } from "react-redux";
import { formatName, formatDate, formatIdWithLength } from "../../../utils/format";
import { useSnackbar } from "notistack";
import CustomToast from "../../../components/CustomToast";
import {
    handleSortByHeader,
    TableHeader,
    setCurrentPage,
    setSuccess,
} from "../../../reducers/superUser";
import i18n from 'i18next';

const UserList = ({ userList }: any) => {
    const navigate = useNavigate();
    const dispatch = useDispatch<ThunkDispatch<any, any, any>>();
    const {
        currentPage,
        countItems,
        pageSize,
        tableHeaders,
        success,
        actionName,
        isSearch,
    } = useSelector((state: any) => state.superUser);

    const userRecord = userList.map((item: any) => ({
        ...item,
        name: formatName(item.first_name, item.last_name),
        created_at: formatDate(item.created_at),
    }));

    const handleSort = (sortHeader: TableHeader) => {
        dispatch(handleSortByHeader(sortHeader));
    };

    const handleChangePage = (pageNumber: any) => {
        dispatch(setCurrentPage(pageNumber));
    };

    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    useEffect(() => {
        if(success && actionName == "deleteSuperUserDetail") {
            enqueueSnackbar("I love snacks.", {
                content: (key) => (
                <CustomToast
                    title={"メッセージ"}
                    message={success}
                    variant={"success"}
                    snackbarKey={key}
                    closeSnackbar={closeSnackbar}
                />
                ),
            });
            dispatch(setSuccess(null));
        }
    }, [success, actionName]);

    return (
        <>
        <div className="rounded-t-lg px-4 py-2 bg-white border-b alu-border">
            <CustomButton
                type="button"
                size="md"
                onClick={() => navigate("/control/user/register")}
            >
                新規登録
            </CustomButton>
        </div>
        {isSearch && userList.length === 0
        ? <div className="bg-white mb-6 px-4 py-4">
            <p className="font-normal text-sm leading-[1.3125] alu-text-base-2">{i18n.t('MSG_GLOBAL_NO_SEARCH_RESULTS')}</p>
        </div>
        : <>
        <div className="bg-white mb-6">
            <table className="table-fixed w-full">
                <thead className="border-b alu-border px-4 py-2">
                    <tr>
                    {tableHeaders.map((header: TableHeader, index: number) => (
                        <th
                        key={index}
                        className={`px-4 py-2 text-left ${
                            header.customStyle ? header.customStyle : ""}`}
                        >
                        <div
                            className="flex items-center"
                            onClick={() => header.isSort && handleSort(header)}
                        >
                            <p
                            className={`${
                                header.currentSortState !== 0
                                ? "font-bold underline underline-offset-4 alu-text-base-2"
                                : "font-normal alu-text-base-1"
                            } ${
                                header.isSort ? "hover:cursor-pointer" : ""
                            } text-sm leading-[1.3125]`}
                            >
                            {header.title}
                            </p>
                            {header.isSort && (
                            <button
                                className={`${
                                header.currentSortState === 2
                                    ? "rotate-180"
                                    : "rotate-0"
                                }`}
                            >
                                <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                >
                                <g clipPath="url(#clip0_8574_176)">
                                    <path d="M7 10L12 15L17 10H7Z" fill="#808080" />
                                </g>
                                <defs>
                                    <clipPath id="clip0_8574_176">
                                    <rect width="24" height="24" fill="white" />
                                    </clipPath>
                                </defs>
                                </svg>
                            </button>
                            )}
                        </div>
                        </th>
                    ))}
                    </tr>
                </thead>
                <tbody>
                    {userRecord.map((user: any, idx: number) => (
                    <tr
                        className="border-b border-b-[#E0E0E0] hover:bg-[#fff3e5]"
                        key={idx}
                    >
                        <td className="px-4 py-2 text-left font-normal text-sm leading-[1.3125] alu-text-base-2">
                            {formatIdWithLength(user.id)}
                        </td>
                        <td
                            onClick={() => navigate("/control/user/detail/" + user.id)}
                            className="min-w-[7rem] hover:cursor-pointer px-4 py-2 text-left font-normal text-sm leading-[1.3125] alu-text-base-2"
                        >
                            {user.name}
                        </td>
                        <td className="break-words whitespace-normal px-4 py-2 text-left font-normal text-sm leading-[1.3125] alu-text-base-2">
                            {user.email}
                        </td>
                        <td className="flex items-center">
                            <p className="px-4 py-2 text-left font-normal text-sm leading-[1.3125] alu-text-base-2 min-w-[144px]">{user.created_at}</p>
                            <p
                                onClick={() => navigate("/control/user/detail/" + user.id)}
                                className="hover:cursor-pointer min-w-[80px] px-4 py-4 text-center font-normal text-sm leading-[1.3125] alu-text-title"
                            >詳細</p>
                            <p
                                onClick={() => navigate("/control/user/edit/" + user.id)}
                                className="hover:cursor-pointer min-w-[80px] px-4 py-4 text-center font-normal text-sm leading-[1.3125] alu-text-title"
                            >編集</p>
                        </td>
                    </tr>
                    ))}
                </tbody>
            </table>
        </div>
        {countItems > pageSize && (
        <div className="flex items-center justify-center mb-10">
            <CustomPagination 
                total={countItems} 
                currentPage={currentPage}
                pageSize={pageSize} 
                onPageChange={handleChangePage} 
                shape="circle"
            />
        </div>
        )}
        </>
        }
        </>
    );
};

export default UserList;
